import { render } from "./IndexOptions.vue?vue&type=template&id=511cb72c"
import script from "./IndexOptions.vue?vue&type=script&lang=js"
export * from "./IndexOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__